import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Package, ExternalLink, CornerUpLeft } from 'lucide-react';
import { formatCurrencyBRL } from '../../utils/formatCurrency';
import './ProductResultCard.css';

function ProductResultCard({ product, onUseInSearch }) {
  const navigate = useNavigate();

  if (!product) return null;

  const {
    id,
    nome,
    sku,
    preco_venda: precoVenda,
    estoque_disponivel: estoqueDisponivel,
    local_estoque: localEstoque,
    descricao_ecommerce: descricaoEcommerce,
    trecho_descricao: trechoDescricao,
    marca,
    grupo,
  } = product;

  const handleOpen = () => {
    if (id) navigate(`/erp/produtos/produtos/${id}`);
  };

  const handleUseInSearch = (e) => {
    e.stopPropagation();
    const label = (nome || sku || '').trim();
    if (label && onUseInSearch) {
      onUseInSearch(label);
    }
  };

  const handleOpenClick = (e) => {
    e.stopPropagation();
    handleOpen();
  };

  return (
    <div className="product-result-card">
      <div className="product-result-card-header">
        <div className="product-result-card-icon">
          <Package size={16} />
        </div>
        <button
          type="button"
          className="product-result-card-title-wrap product-result-card-title-btn"
          onClick={handleOpenClick}
          title="Abrir ficha do produto"
        >
          <span className="product-result-card-name">{nome || 'Produto'}</span>
          {sku && <span className="product-result-card-sku">SKU: {sku}</span>}
        </button>
        <div className="product-result-card-actions">
          {onUseInSearch && (
            <button
              type="button"
              className="product-result-card-action product-result-card-action-search"
              onClick={handleUseInSearch}
              title="Usar nome na pergunta"
              aria-label="Usar nome do produto na pergunta"
            >
              <CornerUpLeft size={14} />
            </button>
          )}
          <button
            type="button"
            className="product-result-card-action"
            onClick={handleOpenClick}
            title="Abrir ficha do produto"
            aria-label="Abrir ficha do produto"
          >
            <ExternalLink size={14} />
          </button>
        </div>
      </div>

      <div className="product-result-card-meta">
        <span className="product-result-card-price">
          {formatCurrencyBRL(precoVenda ?? 0)}
        </span>
        <span
          className={`product-result-card-stock ${
            (estoqueDisponivel ?? 0) > 0
              ? 'product-result-card-stock-available'
              : 'product-result-card-stock-empty'
          }`}
        >
          {(estoqueDisponivel ?? 0) > 0
            ? `${estoqueDisponivel} disp.`
            : 'Sem estoque'}
        </span>
      </div>

      {(marca || grupo) && (
        <p className="product-result-card-tags">
          {[marca, grupo].filter(Boolean).join(' · ')}
        </p>
      )}

      {localEstoque && (
        <p className="product-result-card-location">
          <MapPin size={12} />
          {localEstoque}
        </p>
      )}

      {(trechoDescricao || descricaoEcommerce) && (
        <p className="product-result-card-desc">{trechoDescricao || descricaoEcommerce}</p>
      )}
    </div>
  );
}

export default ProductResultCard;
